import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20">
      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 rounded-none overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20warm%20gradient%20from%20terracotta%20to%20cream%20with%20soft%20organic%20curves%2C%20elegant%20flowing%20shapes%2C%20gentle%20ambient%20light%2C%20clean%20modern%20design%2C%20editorial%20quality%2C%20warm%20atmosphere%2C%20no%20text&width=1920&height=600&seq=cta-bg-fanhao-02&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40"></div>

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
            {t('home:sectionCTA')}
          </h2>
          <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg mx-auto leading-relaxed">
            {t('home:sectionCTADesc')}
          </p>
          <Link
            to="/category/quanxin"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('home:btnCTA')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}